import { render, staticRenderFns } from "./GestioneContainer.vue?vue&type=template&id=5a43e814&"
import script from "./GestioneContainer.vue?vue&type=script&lang=js&"
export * from "./GestioneContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports